module.exports = __webpack_public_path__ + "static/img/MV5.f25b85b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/MV5.jpg
// module id = rkc3
// module chunks = 0